import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MessageBannerComponent } from './message-banner/message-banner.component';

@NgModule({
    declarations: [],
    imports: [CommonModule, IonicModule, RouterModule,
MessageBannerComponent],
    exports: [MessageBannerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MessageComponentsModule {}
